import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { AdminFeatureRoutingModule } from "./admin-feature-routing.module";
import { SharedService } from "../../modules/shared/services/shared.service";
import { LocalDataService } from "../../modules/shared/services/local-data.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AccountService } from "../../modules/shared/services/account.service";
import { EventService } from "../../modules/shared/services/event.service";
import { CatalogService } from "../../modules/shared/services/catalog.service";
import { SessionService } from "../../modules/shared/services/session-service";
import { SessionWidgetService } from "../../modules/shared/services/session-widget.service";
import { FlashMessagesModule } from "angular2-flash-messages";
import { SharedModule } from "../shared-module/shared-module";
import { NgxFitTextModule } from "ngx-fit-text";
import { AceEditorModule } from 'ng2-ace-editor';

import {
    AdminFeatureView,
    CatalogContextView,
    SettingPageView,
    DefaultSetupView,
    ThemePageView,
    ThemeConfigView,
    ElementPageView,
    LayoutPageView,
    HeaderPageView,
    HtmlPageView,
    SessionPageView,
    TemplateConfigView,
    ImageConfigView,
    RegionConfigView,
    HtmlConfigView,
    LabelConfigView,
    SpeakerPageView,
    TabsPageView,
    TabConfigView,
    DataPageView,
    GeneralPageView,
    HighlightedPageView,
    FilterPageView,
    FilterConfigView,
    FilterConfigSectionView,
    FilterCustomizeDisplaySectionView,
    GroupingCustomizeDisplaySectionView,
    ListService,
    DefaultDrawerView,
    DefaultPopupView,
    SessionConfigView,
    AdditionalSettingPageView,
    MySessionPageView,
    LoginPageView,
    MysessionConfigView,
    LoginConfigView,
    LoginConfigSectionView,
    ConfigAfterLoginSectionView,
    SessionExpiredConfigView,
    EditFilterLabelView,
    ButtonConfigView,
    CalendarTemplateView,
    SettingView,
    CalendarConfigView,
    MyscheduleConfigView,
    AssetConfigView,
 	AssetDisplayConfigView,
    SaveFilterConfigView,
    TimezoneSettingView,
    RulesValidationView,
    MyresourcesConfigView,
    SessionResourcesPageView,
    ResourceAssetConfigView,
    ResourceAssetDisplayConfigView,
    RecommendationWidgetPageView,
    WidgetConfigPageView,
    WidgetTextConfigPageView,
    RecommendationsPageView
} from ".";
import {
    CclListModule,
    CclNavigationModule,
    CclSharedModule,
    CclLayoutModule,
    CclPageBuilderModule,
    CclPaletteModule,
    CclTemplateResolverService,
    CclNavbarSecondaryService,
    CclBuilderService,
    CclFormsModule,
    CclMessageService,
    CclQuestionBuilderModule
} from "certain-common-library";
import { AttendeeSessionService } from "../../modules/shared/services/attendee-session.service";
import { UploadService } from "../../modules/shared/services/upload.service";
import { CanDeactivateGuard } from "./can-deactivate";

@NgModule({
    declarations: [
        AdminFeatureView,
        CatalogContextView,
        SettingPageView,
        DefaultSetupView,
        ThemePageView,
        ThemeConfigView,
        ElementPageView,
        LayoutPageView,
        HeaderPageView,
        HtmlPageView,
        SessionPageView,
        TemplateConfigView,
        ImageConfigView,
        RegionConfigView,
        HtmlConfigView,
        LabelConfigView,
        SpeakerPageView,
        TabsPageView,
        TabConfigView,
        DataPageView,
        GeneralPageView,
        HighlightedPageView,
        FilterPageView,
        FilterConfigView,
        FilterConfigSectionView,
        FilterCustomizeDisplaySectionView,
        GroupingCustomizeDisplaySectionView,
        DefaultDrawerView,
        DefaultPopupView,
        SessionConfigView,
        AdditionalSettingPageView,
        MySessionPageView,
        LoginPageView,
        LoginConfigSectionView,
        ConfigAfterLoginSectionView,
        SessionExpiredConfigView,
        MysessionConfigView,
        LoginConfigView,
        EditFilterLabelView,
        ButtonConfigView,
        CalendarTemplateView,
        SettingView,
        CalendarConfigView,
        MyscheduleConfigView,
        AssetConfigView,
 	    AssetDisplayConfigView,
        SaveFilterConfigView,
        TimezoneSettingView,
        RulesValidationView,
        SessionResourcesPageView,
        MyresourcesConfigView,
        ResourceAssetConfigView,
        ResourceAssetDisplayConfigView,
        RecommendationWidgetPageView,
        WidgetConfigPageView,
        WidgetTextConfigPageView,
        RecommendationsPageView
    ],
    imports: [
        AdminFeatureRoutingModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        NgbModule,
        CclListModule,
        CclNavigationModule,
        CclSharedModule,
        CclLayoutModule,
        CclPageBuilderModule,
        CclPaletteModule,
        CclFormsModule,
        CclQuestionBuilderModule,
        FlashMessagesModule.forRoot(),
        SharedModule,
        NgxFitTextModule.forRoot(),
        AceEditorModule
    ],
    providers: [
        CclTemplateResolverService,
        CclNavbarSecondaryService,
        CclBuilderService,
        CclMessageService,
        ListService,
        SharedService,
        LocalDataService,
        AccountService,
        EventService,
        CatalogService,
        SessionService,
        AttendeeSessionService,
        UploadService,
        CanDeactivateGuard,
        SessionWidgetService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AdminFeatureModule {}
